import * as React from 'react';
import { IconActionChevronLeft24 } from '@cian/ui-kit-design-tokens/icons';

import * as s from './IconChevronDown24.css';

export const IconChevronDown24 = () => {
  return (
    <div className={s['wrapper']}>
      <IconActionChevronLeft24 />
    </div>
  );
};
